import React from "react";
import BarChartsHorizontal from "../../../Components/Charts/BarChartsHorizontal.js";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service.jsx";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";

const stock_region = async (body) => {
  try {
    const res = await axInst.post("stocks/region-wise-stocks", body);
    const buckets = res.data.region_wise_stocks;

    const keyData = buckets.map((bucket) => bucket.key).reverse();
    const valData = buckets.map((bucket) => bucket.doc_count).reverse();

    return {
      keyData,
      valData,
    };
  } catch (error) {
    console.error(error);
  }
};

const StockRegionWise = () => {
  const { data, submitted } = useSelector((e) => e.filtersStock);

  const {
    data: horichart,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["horichart", submitted],
    queryFn: () => stock_region(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  return (
    <div className=" relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && (
        <div>
          <BarChartsHorizontal
            data={horichart}
            heading={"Region Wise Stocks"}
            h={"230px"}
            p={"right"}
          />
        </div>
      )}
    </div>
  );
};

export default StockRegionWise;
